'use client';

import { useMemo } from 'react';
import { Text } from '@chakra-ui/react';
import { useGiftcardsPagesLayoutContent } from 'context/giftcardsPagesLayoutContent';

export interface GiftcardDescriptionProps {
  giftcard: AdaptedGiftcard;
}

export const GiftcardDescription = (props: GiftcardDescriptionProps) => {
  const { giftcard } = props;

  const { giftcardInfo } = useGiftcardsPagesLayoutContent();

  const activationDeadlineDescription = useMemo(() => {
    if (!giftcard?.activation?.sponsor) return '';

    return giftcardInfo.activationDeadline.replaceAll(
      '<<activationClosesAt>>',
      giftcard.activation.formatted.sponsor.activationClosesAt,
    );
  }, [giftcard]);

  const description = useMemo(() => {
    if (!giftcardInfo) return '';

    if (!giftcard?.activation?.sponsor?.creditsExpireAt) {
      return giftcardInfo.generalInfo;
    }

    return giftcardInfo.creditExpiration.replace(
      '<<creditsExpireAt>>',
      giftcard.activation.formatted.sponsor.creditsExpireAt,
    );
  }, [giftcard]);

  return (
    <>
      {activationDeadlineDescription && (
        <Text fontSize="0.75rem" lineHeight="0.875rem" mx="auto">
          {activationDeadlineDescription}
        </Text>
      )}

      <Text fontSize="0.75rem" lineHeight="0.875rem" mx="auto">
        {description}
      </Text>
    </>
  );
};
